/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayoutOrderServiceCountOrdersParams,
    type AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    type AdminPayoutOrderServiceGetOrderChecksParams,
    type AdminPayoutOrderServiceGetOrderEventsParams,
    type AdminPayoutOrderServiceGetOrderParams,
    type AdminPayoutOrderServiceListOrdersParams,
    type GoogleRpcStatus,
    type PayoutAdminOrderV1ApproveOrderRequest,
    type PayoutAdminOrderV1ApproveOrderResponse,
    type PayoutAdminOrderV1CancelOrderRequest,
    type PayoutAdminOrderV1CancelOrderResponse,
    type PayoutAdminOrderV1CountOrdersResponse,
    type PayoutAdminOrderV1DeclineOrderRequest,
    type PayoutAdminOrderV1DeclineOrderResponse,
    type PayoutAdminOrderV1GetOrderCascadeEventsResponse,
    type PayoutAdminOrderV1GetOrderChecksResponse,
    type PayoutAdminOrderV1GetOrderEventsResponse,
    type PayoutAdminOrderV1GetOrderResponse,
    type PayoutAdminOrderV1InvestigateOrderRequest,
    type PayoutAdminOrderV1InvestigateOrderResponse,
    type PayoutAdminOrderV1ListOrdersResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayoutOrderServiceGetOrderUrl = (params?: AdminPayoutOrderServiceGetOrderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order?${stringifiedParams}` : '/v1/order';
};

/**
 * @summary Requires orders.read.
 */
export const adminPayoutOrderServiceGetOrder = async (
    params?: AdminPayoutOrderServiceGetOrderParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1GetOrderResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1GetOrderResponse>(getAdminPayoutOrderServiceGetOrderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutOrderServiceGetOrderQueryKey = (params?: AdminPayoutOrderServiceGetOrderParams) => {
    return ['/v1/order', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceGetOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceGetOrderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>> = ({ signal }) =>
        adminPayoutOrderServiceGetOrder(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceGetOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>
>;
export type AdminPayoutOrderServiceGetOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceGetOrderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.read.
 */

export function useAdminPayoutOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceGetOrderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceGetOrderCascadeEventsUrl = (
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/cascade/events?${stringifiedParams}` : '/v1/order/cascade/events';
};

/**
 * @summary Requires orders.history.read.
 */
export const adminPayoutOrderServiceGetOrderCascadeEvents = async (
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1GetOrderCascadeEventsResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1GetOrderCascadeEventsResponse>(
        getAdminPayoutOrderServiceGetOrderCascadeEventsUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutOrderServiceGetOrderCascadeEventsQueryKey = (
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
) => {
    return ['/v1/order/cascade/events', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceGetOrderCascadeEventsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceGetOrderCascadeEventsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>> = ({
        signal,
    }) => adminPayoutOrderServiceGetOrderCascadeEvents(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceGetOrderCascadeEventsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>
>;
export type AdminPayoutOrderServiceGetOrderCascadeEventsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceGetOrderCascadeEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderCascadeEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderCascadeEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.history.read.
 */

export function useAdminPayoutOrderServiceGetOrderCascadeEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderCascadeEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderCascadeEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceGetOrderCascadeEventsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceGetOrderChecksUrl = (params?: AdminPayoutOrderServiceGetOrderChecksParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/checks?${stringifiedParams}` : '/v1/order/checks';
};

/**
 * @summary Requires orders.read; check processing and finalization are internal behavior.
 */
export const adminPayoutOrderServiceGetOrderChecks = async (
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1GetOrderChecksResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1GetOrderChecksResponse>(
        getAdminPayoutOrderServiceGetOrderChecksUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutOrderServiceGetOrderChecksQueryKey = (
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
) => {
    return ['/v1/order/checks', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceGetOrderChecksQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceGetOrderChecksQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>> = ({ signal }) =>
        adminPayoutOrderServiceGetOrderChecks(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceGetOrderChecksQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>
>;
export type AdminPayoutOrderServiceGetOrderChecksQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceGetOrderChecksParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.read; check processing and finalization are internal behavior.
 */

export function useAdminPayoutOrderServiceGetOrderChecks<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderChecksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderChecks>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceGetOrderChecksQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceCountOrdersUrl = (params?: AdminPayoutOrderServiceCountOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/count?${stringifiedParams}` : '/v1/order/count';
};

/**
 * @summary Requires orders.read.
 */
export const adminPayoutOrderServiceCountOrders = async (
    params?: AdminPayoutOrderServiceCountOrdersParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1CountOrdersResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1CountOrdersResponse>(getAdminPayoutOrderServiceCountOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutOrderServiceCountOrdersQueryKey = (params?: AdminPayoutOrderServiceCountOrdersParams) => {
    return ['/v1/order/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceCountOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceCountOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>> = ({ signal }) =>
        adminPayoutOrderServiceCountOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceCountOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>
>;
export type AdminPayoutOrderServiceCountOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceCountOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.read.
 */

export function useAdminPayoutOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceCountOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceGetOrderEventsUrl = (params?: AdminPayoutOrderServiceGetOrderEventsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/events?${stringifiedParams}` : '/v1/order/events';
};

/**
 * @summary Requires orders.history.read.
 */
export const adminPayoutOrderServiceGetOrderEvents = async (
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1GetOrderEventsResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1GetOrderEventsResponse>(
        getAdminPayoutOrderServiceGetOrderEventsUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutOrderServiceGetOrderEventsQueryKey = (
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
) => {
    return ['/v1/order/events', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceGetOrderEventsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceGetOrderEventsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>> = ({ signal }) =>
        adminPayoutOrderServiceGetOrderEvents(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceGetOrderEventsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>
>;
export type AdminPayoutOrderServiceGetOrderEventsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceGetOrderEventsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.history.read.
 */

export function useAdminPayoutOrderServiceGetOrderEvents<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceGetOrderEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceGetOrderEvents>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceGetOrderEventsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceListOrdersUrl = (params?: AdminPayoutOrderServiceListOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders?${stringifiedParams}` : '/v1/orders';
};

/**
 * @summary Requires orders.read.
 */
export const adminPayoutOrderServiceListOrders = async (
    params?: AdminPayoutOrderServiceListOrdersParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1ListOrdersResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1ListOrdersResponse>(getAdminPayoutOrderServiceListOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutOrderServiceListOrdersQueryKey = (params?: AdminPayoutOrderServiceListOrdersParams) => {
    return ['/v1/orders', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutOrderServiceListOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutOrderServiceListOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>> = ({ signal }) =>
        adminPayoutOrderServiceListOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceListOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>
>;
export type AdminPayoutOrderServiceListOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutOrderServiceListOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires orders.read.
 */

export function useAdminPayoutOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceListOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceApproveOrderUrl = () => {
    return '/v1/orders/approve';
};

/**
 * @summary Для ордеров в статусе STATUS_INVESTIGATION решает спор в пользу трейдера
завершает ордер в статус STATUS_INVESTIGATION_APPROVED и обновляет баланс трейдера
Requires orders.approve.
 */
export const adminPayoutOrderServiceApproveOrder = async (
    payoutAdminOrderV1ApproveOrderRequest: PayoutAdminOrderV1ApproveOrderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1ApproveOrderResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1ApproveOrderResponse>(getAdminPayoutOrderServiceApproveOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminOrderV1ApproveOrderRequest),
    });
};

export const getAdminPayoutOrderServiceApproveOrderQueryKey = (
    payoutAdminOrderV1ApproveOrderRequest?: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
) => {
    return ['POST', '/v1/orders/approve', payoutAdminOrderV1ApproveOrderRequest] as const;
};

export const getAdminPayoutOrderServiceApproveOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1ApproveOrderRequest: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayoutOrderServiceApproveOrderQueryKey(payoutAdminOrderV1ApproveOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>> = ({ signal }) =>
        adminPayoutOrderServiceApproveOrder(payoutAdminOrderV1ApproveOrderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceApproveOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>
>;
export type AdminPayoutOrderServiceApproveOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1ApproveOrderRequest: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1ApproveOrderRequest: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1ApproveOrderRequest: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Для ордеров в статусе STATUS_INVESTIGATION решает спор в пользу трейдера
завершает ордер в статус STATUS_INVESTIGATION_APPROVED и обновляет баланс трейдера
Requires orders.approve.
 */

export function useAdminPayoutOrderServiceApproveOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1ApproveOrderRequest: BodyType<PayoutAdminOrderV1ApproveOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceApproveOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceApproveOrderQueryOptions(
        payoutAdminOrderV1ApproveOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceCancelOrderUrl = () => {
    return '/v1/orders/cancel';
};

/**
 * @summary Отменяет ордер до принятия трейдером в работу.
Requires orders.cancel.
 */
export const adminPayoutOrderServiceCancelOrder = async (
    payoutAdminOrderV1CancelOrderRequest: PayoutAdminOrderV1CancelOrderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1CancelOrderResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1CancelOrderResponse>(getAdminPayoutOrderServiceCancelOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminOrderV1CancelOrderRequest),
    });
};

export const getAdminPayoutOrderServiceCancelOrderQueryKey = (
    payoutAdminOrderV1CancelOrderRequest?: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
) => {
    return ['POST', '/v1/orders/cancel', payoutAdminOrderV1CancelOrderRequest] as const;
};

export const getAdminPayoutOrderServiceCancelOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1CancelOrderRequest: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayoutOrderServiceCancelOrderQueryKey(payoutAdminOrderV1CancelOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>> = ({ signal }) =>
        adminPayoutOrderServiceCancelOrder(payoutAdminOrderV1CancelOrderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceCancelOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>
>;
export type AdminPayoutOrderServiceCancelOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceCancelOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1CancelOrderRequest: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceCancelOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1CancelOrderRequest: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceCancelOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1CancelOrderRequest: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Отменяет ордер до принятия трейдером в работу.
Requires orders.cancel.
 */

export function useAdminPayoutOrderServiceCancelOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1CancelOrderRequest: BodyType<PayoutAdminOrderV1CancelOrderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceCancelOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceCancelOrderQueryOptions(
        payoutAdminOrderV1CancelOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceDeclineOrderUrl = () => {
    return '/v1/orders/decline';
};

/**
 * @summary Для ордеров в статусе STATUS_INVESTIGATION (спор) решает спор не в пользу трейдера
завершает ордер в статус STATUS_INVESTIGATION_DECLINED без возмещения средств трейдеру
Requires orders.decline.
 */
export const adminPayoutOrderServiceDeclineOrder = async (
    payoutAdminOrderV1DeclineOrderRequest: PayoutAdminOrderV1DeclineOrderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1DeclineOrderResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1DeclineOrderResponse>(getAdminPayoutOrderServiceDeclineOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminOrderV1DeclineOrderRequest),
    });
};

export const getAdminPayoutOrderServiceDeclineOrderQueryKey = (
    payoutAdminOrderV1DeclineOrderRequest?: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
) => {
    return ['POST', '/v1/orders/decline', payoutAdminOrderV1DeclineOrderRequest] as const;
};

export const getAdminPayoutOrderServiceDeclineOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1DeclineOrderRequest: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayoutOrderServiceDeclineOrderQueryKey(payoutAdminOrderV1DeclineOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>> = ({ signal }) =>
        adminPayoutOrderServiceDeclineOrder(payoutAdminOrderV1DeclineOrderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceDeclineOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>
>;
export type AdminPayoutOrderServiceDeclineOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1DeclineOrderRequest: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1DeclineOrderRequest: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1DeclineOrderRequest: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Для ордеров в статусе STATUS_INVESTIGATION (спор) решает спор не в пользу трейдера
завершает ордер в статус STATUS_INVESTIGATION_DECLINED без возмещения средств трейдеру
Requires orders.decline.
 */

export function useAdminPayoutOrderServiceDeclineOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1DeclineOrderRequest: BodyType<PayoutAdminOrderV1DeclineOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceDeclineOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceDeclineOrderQueryOptions(
        payoutAdminOrderV1DeclineOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutOrderServiceInvestigateOrderUrl = () => {
    return '/v1/orders/investigate';
};

/**
 * @summary Переводит ордер в статус STATUS_INVESTIGATION.
Доступно для ордеров, которые находятся в работе или ожидают подтверждения выплаты.
Requires orders.investigate.
 */
export const adminPayoutOrderServiceInvestigateOrder = async (
    payoutAdminOrderV1InvestigateOrderRequest: PayoutAdminOrderV1InvestigateOrderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminOrderV1InvestigateOrderResponse> => {
    return payoutKyMutator<PayoutAdminOrderV1InvestigateOrderResponse>(
        getAdminPayoutOrderServiceInvestigateOrderUrl(),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminOrderV1InvestigateOrderRequest),
        },
    );
};

export const getAdminPayoutOrderServiceInvestigateOrderQueryKey = (
    payoutAdminOrderV1InvestigateOrderRequest?: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
) => {
    return ['POST', '/v1/orders/investigate', payoutAdminOrderV1InvestigateOrderRequest] as const;
};

export const getAdminPayoutOrderServiceInvestigateOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1InvestigateOrderRequest: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutOrderServiceInvestigateOrderQueryKey(payoutAdminOrderV1InvestigateOrderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>> = ({ signal }) =>
        adminPayoutOrderServiceInvestigateOrder(payoutAdminOrderV1InvestigateOrderRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutOrderServiceInvestigateOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>
>;
export type AdminPayoutOrderServiceInvestigateOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutOrderServiceInvestigateOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1InvestigateOrderRequest: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceInvestigateOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1InvestigateOrderRequest: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutOrderServiceInvestigateOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1InvestigateOrderRequest: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Переводит ордер в статус STATUS_INVESTIGATION.
Доступно для ордеров, которые находятся в работе или ожидают подтверждения выплаты.
Requires orders.investigate.
 */

export function useAdminPayoutOrderServiceInvestigateOrder<
    TData = Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminOrderV1InvestigateOrderRequest: BodyType<PayoutAdminOrderV1InvestigateOrderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutOrderServiceInvestigateOrder>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutOrderServiceInvestigateOrderQueryOptions(
        payoutAdminOrderV1InvestigateOrderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
